import { render } from "./LogoCases.vue?vue&type=template&id=19b6cd51"
import script from "./LogoCases.vue?vue&type=script&lang=js"
export * from "./LogoCases.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__